import React from 'react'

export const hasDisplayName = (
  type: React.JSXElementConstructor<unknown>
): type is React.JSXElementConstructor<unknown> & { displayName: string } => {
  return 'displayName' in type && typeof type.displayName === 'string'
}

export const findOneByName = (children: React.ReactNode, name: string) => {
  return React.Children.toArray(children).find(child => {
    if (!React.isValidElement(child)) return false
    if (child.type && typeof child.type === 'function' && 'displayName' in child.type) {
      return child.type.displayName === name
    }
    if (child.type && typeof child.type === 'object' && 'displayName' in child.type) {
      // @ts-expect-error type error
      return child.type.displayName === name
    }
    return false
  })
}

export const extractNames = (children: React.ReactNode): string[] => {
  const names: string[] = []

  const traverse = (child: React.ReactNode) => {
    if (React.isValidElement(child)) {
      if (child.props?.name && typeof child.props.name === 'string') {
        names.push(child.props.name)
      }

      if (typeof child.type === 'function') {
        if (child.props?.name && typeof child.props.name === 'string') {
          names.push(child.props.name)
        }
      }

      if (child.props?.children) {
        React.Children.forEach(child.props.children, traverse)
      }
    }
  }

  React.Children.forEach(children, traverse)
  return [...new Set(names)]
}
